export default __webpack_public_path__ + "static/poster-8a707a7d445b3172dfcdcc28cd0bebb6.png";